const formatter = (data: {
  name: string;
  subregion_name?: string;
  region_name?: string;
}) =>
  `${data?.name}${data?.subregion_name ? `, ${data?.subregion_name}` : ``}${
    data?.region_name ? `, ${data?.region_name}` : ""
  }`;

export const propToFormatCityLabelWithRhSelect = {
  getOptionLabel: formatter,
  getChipLabel: formatter,
};
